import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
  loadUserApplications,
  selectCurrentApplication,
  selectAvailableApplications,
  selectApplicationLoading,
  selectApplicationError,
  selectCurrentApplicationObject,
} from '../store/slices/application.slice';

export const useApplication = () => {
  const dispatch = useAppDispatch();
  const selectedAppId = useAppSelector(selectCurrentApplication);
  const availableApps = useAppSelector(selectAvailableApplications);
  const loading = useAppSelector(selectApplicationLoading);
  const error = useAppSelector(selectApplicationError);
  const currentApp = useAppSelector(selectCurrentApplicationObject);

  useEffect(() => {
    // Load applications only once on mount
    if (availableApps.length === 0 && !loading && !error) {
      dispatch(loadUserApplications());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount

  return {
    selectedAppId,
    availableApps,
    loading,
    error,
    currentApp,
  };
};
